import { memo } from 'react';
import { PromotionReward } from '@betty/promos';
import { RewardLabelProps } from './RewardsLabel.types';
import { Box, Icon, Text } from '@betty/moonlight';
import { rewardsDescriptionMap } from './RewardsLabel.constants';
import { formatCompact } from '@betty/toolkit/utils';

const getRewardAmountFormatted = (reward: PromotionReward) => {
  const amount = formatCompact(reward?.rewardAmount ?? 0);
  return reward?.rewardTarget === 'Cash' ? `$${amount}` : amount;
};

function RewardsLabel({
  rewards,
  groupGap = 'space-200',
  overlapOffset = 'space-100',
}: RewardLabelProps) {
  if (!rewards?.length) return null;

  if (rewards.length === 1) {
    const reward = rewards[0];
    return (
      <Box alignItems="center">
        <Text variant="giant" gradient="darkSurfaceAccent" textAlign="center">
          {getRewardAmountFormatted(reward as PromotionReward)}
        </Text>
        <Box position="relative" top={overlapOffset}>
          <Text variant="h4" gradient="darkSurfaceAccent" textAlign="center">
            {rewardsDescriptionMap.get(reward.rewardTarget)}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box alignItems="center">
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        gap={groupGap}
      >
        {rewards.map((reward, index) => (
          <Box
            key={`${reward.rewardTarget}-${index}`}
            flexDirection="row"
            alignItems="center"
          >
            <Box alignItems="center" gap="space-050" minWidth={96}>
              <Text
                variant="h4"
                gradient="darkSurfaceAccent"
                uppercase
                textAlign="center"
                numberOfLines={1}
              >
                {getRewardAmountFormatted(reward as PromotionReward)}
              </Text>
              <Text
                variant="h6"
                gradient="darkSurfaceAccent"
                uppercase
                textAlign="center"
                numberOfLines={1}
              >
                {rewardsDescriptionMap.get(reward.rewardTarget)}
              </Text>
            </Box>
            {index < rewards.length - 1 && (
              <Box
                alignItems="center"
                justifyContent="center"
                paddingHorizontal="space-200"
              >
                <Icon name="plusReward" width={24} height={24} />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
export default memo(RewardsLabel);
